;(function (_, $) {

  $(document).on('click', '.desti-menu-trigger', function () {
    const parent = $(this).parent();

    parent.siblings().removeClass('open');

    $(this).parent().toggleClass('open');
  });

  $(document).ready(function () {
    const hamburgerButton = $('#hamburger-menu-toggle');
    const primaryNavBar = $('.primary-nav-bar');

    hamburgerButton.on('click', function () {
      primaryNavBar.toggleClass('nav-open');

      $(this).toggleClass('active');

      $('.desti-menu-item').removeClass('open');
    });

    // Close menu when clicking outside
    $(document).on('click', function (event) {
      if (!$(event.target).closest('#hamburger-menu-toggle, .primary-nav-bar').length) {
        if (primaryNavBar.hasClass('nav-open') && window.innerWidth <= 1024) {
          hamburgerButton.removeClass('active');
        }

        $('.desti-menu-item').removeClass('open');
      }
    });

    // Handle window resize
    $(window).on('resize', function () {
      if (window.innerWidth > 1024) {
        hamburgerButton.removeClass('active');
      }

      $('.desti-menu-item').removeClass('open');
    });
  });
})(window, jQuery);